import React from 'react';
import { PlayIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const InstallGuide = () => {
  return (
    <div className="md:p-6 max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">
        iFLO Pro Kit Installation Guide
      </h1>

      <div className="bg-white rounded-lg shadow-md md:p-6">
        <h2 className="text-xl font-semibold mb-4">
          Watch Installation Tutorial
        </h2>
        
        <div className="mx-auto">
          <div className="relative w-full pt-[56.25%] bg-gray-100 rounded-lg overflow-hidden mb-6">
            <video 
              className="absolute top-0 left-0 w-full h-full object-cover"
              src="https://cdn.shopify.com/videos/c/o/v/2bf6772b69a24c97a888a24468cfed1a.mp4"
              controls
              playsInline
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        {/*<h2 className="text-xl font-semibold mb-4">
          Quick Installation Steps
        </h2>
        
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <CheckCircleIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
            <div>
              <p className="font-medium">1. Turn off water supply</p>
              <p className="text-gray-600 text-sm">Locate and close the main water valve</p>
            </div>
          </li>
          <li className="flex items-start gap-3">
            <CheckCircleIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
            <div>
              <p className="font-medium">2. Mount the bracket</p>
              <p className="text-gray-600 text-sm">Secure to wall using provided screws</p>
            </div>
          </li>
          <li className="flex items-start gap-3">
            <CheckCircleIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
            <div>
              <p className="font-medium">3. Connect hoses</p>
              <p className="text-gray-600 text-sm">Attach inlet and outlet hoses</p>
            </div>
          </li>
          <li className="flex items-start gap-3">
            <CheckCircleIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
            <div>
              <p className="font-medium">4. Mount the unit</p>
              <p className="text-gray-600 text-sm">Slide onto bracket and connect power</p>
            </div>
          </li>
          <li className="flex items-start gap-3">
            <CheckCircleIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
            <div>
              <p className="font-medium">5. Test the system</p>
              <p className="text-gray-600 text-sm">Turn on water and verify operation</p>
            </div>
          </li>
        </ul>*/}

        {/*<div className="mt-8 flex justify-center">
          <button  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg flex items-center gap-2 transition-colors">
            <PlayIcon className="w-6 h-6" />
            Watch Full Tutorial
          </button>
        </div>*/}
      </div>
    </div>
  );
};

export default InstallGuide;
